// react =>
import { RefObject } from "react";

// api =>
import backEnd from "../../services/Api";

// types =>
import { FetchResult } from "./MainPageType";

// hooks =>
import { useUserStore } from "../../hooks/useUserStore";

export const handleApiError = (error: any): string => {
    let message = "خطای ناشناخته‌ای رخ داده است. لطفاً بعداً دوباره تلاش کنید.";

    if (error.response) {
        const status = error.response.status;

        switch (status) {
            case 400:
                message = "درخواست نامعتبر است. لطفاً ورودی‌ها را بررسی کنید.";
                break;
            case 401:
            case 403:
                useUserStore.getState().setUser(null);
                localStorage.removeItem("user-storage");

                message = "لطفاً ابتدا وارد حساب کاربری خود شوید یا ثبت نام کنید!";
                break;
            case 404:
                message = "موردی یافت نشد.";
                break;
            case 500:
                message = "خطای داخلی سرور. لطفاً بعداً تلاش کنید.";
                break;
            default:
                message = "مشکلی رخ داده است. لطفاً بعداً دوباره تلاش کنید.";
                break;
        }

    } else if (error.request) {
        message = "پاسخی از سرور دریافت نشد. اینترنت خود را چک کنید.";
    } else {
        message = "مشکلی در ارسال درخواست رخ داد.";
    }

    return message;
};

export const fetchStories = async (): Promise<FetchResult> => {
    try {
        const response = await backEnd.get("products/get-story-list/");
        
        const stories = response.data.map((item: any) => ({
            id: item.id,
            story_type: item.story_type,
            file: item.file || "",
            thumbnail: item.thumbnail || undefined,
            caption: item.caption || undefined,
            duration: item.duration ? item.duration * 1000 : 15000,
        }));

        return { status: true, data: stories };

    } catch (error) {
        const errorMessage  = handleApiError(error);
        
        return { 
            status: false, 
            data: [], 
            message: errorMessage
        };
    }
};

export const handleOpenAndPlayStory = (
    storyUrl: string,
    e: React.MouseEvent<HTMLDivElement>,
    videoRef: RefObject<HTMLVideoElement | null>,
    storyFrameRef: RefObject<HTMLDivElement | null>,
) => {
    e.currentTarget.style.borderColor = "gray";

    if (storyFrameRef.current) {
        storyFrameRef.current.style.display = "flex";
    }

    if (videoRef.current) {
        videoRef.current.src = storyUrl;
        videoRef.current.play();
    }
};

export const handleCloseAndPauseStory = (
    videoRef: RefObject<HTMLVideoElement | null>,
    storyFrameRef: RefObject<HTMLDivElement | null>,
) => {
    if (storyFrameRef.current) {
        storyFrameRef.current.style.display = "none";
    }

    if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
    }
};

export const handlePause = (
    videoRef: RefObject<HTMLVideoElement | null>,
) => {
    if (videoRef.current) {
        videoRef.current.pause();
    }
};

export const handlePlay = (
    videoRef: RefObject<HTMLVideoElement | null>,
) => {
    if (videoRef.current) {
        videoRef.current.play();
    }
};
